<template>
  <div class="image-walll w-full h-full overflow-hidden">
    <column-header
      v-show="data.showTitle"
      class="mb-10px"
      :title="title"
      :showMore="data.showMore"
      @loadMore="loadMore"
    />
    <div :class="getBodyClass()" class="flex flex-col">
      <template v-if="list.length">
        <div
          v-for="n in row"
          :key="n"
          class="flex flex-1"
          :class="{
            'mt-25px': n !== 1,
          }"
        >
          <div
            v-for="item in col"
            :key="item"
            :class="{
              'mr-15px': item !== col,
            }"
            :style="{
              width: `calc((100% - ${15 * (col - 1)}px) / ${col})`,
            }"
          >
            <template v-if="list[col * (n - 1) + item - 1]">
              <div class="h-full w-full" @click="toDetail(list[col * (n - 1) + item - 1])">
                <div
                  class="relative w-full"
                  :style="{
                    height: data.showDate ? `calc(100% - 48px)` : `calc(100% - 26px)`,
                  }"
                >
                  <div
                    :style="{
                      height: data.fixedHeight ? '110px' : '100%',
                    }"
                  >
                    <el-image
                      class="absolute h-full w-full cursor-pointer"
                      :src="`${fileUrl}${list[col * (n - 1) + item - 1].indexImage}`"
                      :fit="data.imageFit || 'fill'"
                    >
                    </el-image>
                    <img
                      src="../../assets/images/视频播放.png"
                      alt=""
                      class="absolute m-auto w-30px h-30px object-contain top-1/2 left-1/2"
                      style="transform: translateX(-50%) translateY(-50%)"
                    />
                  </div>
                </div>
                <p
                  class="mt-10px text-16px text-hex-333 truncate hover:text-hex-$portalPrimaryColor w-full"
                  :title="list[col * (n - 1) + item - 1].title"
                >
                  {{ list[col * (n - 1) + item - 1].title }}
                </p>
                <div
                  class="mt-8px cursor-pointer flex items-center justify-between text-hex-999 hover:text-hex-$portalPrimaryColor text-14px"
                  v-if="data.showDate"
                >
                  <div class="flex-1 truncate">
                    浏览: {{ list[col * (n - 1) + item - 1].numberViews }}
                  </div>
                  <div class="truncate ml-10px">
                    {{ dayjs(list[col * (n - 1) + item - 1].editPublishTime).format('YYYY/MM/DD') }}
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <div class="text-right mt-20px">
      <el-pagination
        small
        v-show="data.showPagination"
        background
        @current-change="tableCurrentChange"
        :current-page.sync="page.pageNo"
        layout="total, prev, pager, next"
        :page-size.sync="page.pageSize"
        :total="page.totalCount"
        :pager-count="5"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { ColumnTableApi, ColumApi } from '@wiz-api/workbench-std'
import { informationPublishMap } from '@/modules/portal-management/js/config'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()
const columApi = new ColumApi()
const columnVideoType = informationPublishMap.column.columnVideo // 视频栏目
const columnHeader = () => {
  return import('./ColumnHeader')
}
export default {
  name: 'NewsVideoTwo',
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update', // update/view   update模式不触发点击
    },
  },
  components: {
    columnHeader,
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 1,
        totalCount: 0,
      },
      dataSource: '',
      list: [],
      title: '视频',
      row: 1,
      col: 1,
    }
  },
  methods: {
    loadMore() {
      if (this.mode !== 'update') {
        window.open(
          `${window.location.origin}${window.location.hash ? '/#' : ''}${
            this.routerBase
          }/integration/portal/homepage?columnId=${this.data.dataSource}`
        )
      }
    },
    tableCurrentChange(value) {
      this.page.pageNo = value
      this.getListData()
    },
    getBodyClass() {
      if (this.data.showTitle) {
        if (this.data.showPagination) {
          return 'h-[calc(100%-98px)]'
        }
        return 'h-[calc(100%-50px)]'
      }
      if (this.data.showPagination) {
        return 'h-[calc(100%-48px)]'
      }
      return 'h-full'
    },
    toDetail(item) {
      if (this.mode === 'view') {
        if (item.externalLink) {
          window.open(item.externalLink)
        } else {
          window.open(
            `${window.location.origin}${window.location.hash ? '/#' : ''}${
              this.routerBase
            }/integration/portal/ColumnDetail?id=${item.id}&type=${columnVideoType}`
          )
        }
      }
    },
    async getListData() {
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getVideoColumnTable(this.page.pageNo, this.page.pageSize, {
          columnId: this.data.dataSource,
          isShow: true,
        })
      })
      if (!err) {
        this.list = res.items
        this.page.totalCount = res.totalCount
      }
    },
    async getTitle() {
      if (this.data.title && this.data.dataSource) {
        this.getListData()
        return
      }
      if (this.data.dataSource !== '' && this.data.dataSource != null) {
        const [err, res] = await columApi.getColumnDetail(this.data.dataSource)
        if (!err) {
          this.title = res.name
          this.getListData()
        }
      }
    },
  },
  created() {
    this.getTitle()
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.row = val.row || 1
          this.col = val.col || 1
          if (val.title) this.title = val.title
          if (val.dataSource !== this.dataSource || this.col * this.row !== this.page.pageSize) {
            this.dataSource = this.data.dataSource
            this.page.pageSize = this.col * this.row
            this.getTitle()
          }
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.image-walll {
  &::v-deep .el-carousel {
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__arrow {
      width: 30px;
      height: 40px;
      border-radius: unset;
      background-color: rgba(0, 0, 0, 0.3);
      &:hover {
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
    .el-carousel__arrow--left {
      left: 0;
    }
    .el-carousel__arrow--right {
      right: 0;
    }
  }
}
</style>
